import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { CalendarClock, MessageSquareText, X, Loader2, Award } from "lucide-react";
import ApptEditDialog from "@/components/ApptEditDialog";

const COLORS = ["#A855F7", "#EC4899", "#10B981", "#F59E0B", "#38BDF8"];

export default function CaptureSuccess({ lead, onClose }) {
  const [rdv, setRdv] = useState(false);
  const [smsLoading, setSmsLoading] = useState(false);
  const c = lead.contactInfo || {};
  const name = [c.firstName, c.lastName].filter(Boolean).join(" ") || c.company || "Nouveau prospect";
  const tomorrow = new Date(Date.now() + 86400000).toISOString().slice(0, 10);

  const sendSms = async () => {
    if (!lead.id) { toast("Disponible après synchronisation"); return; }
    setSmsLoading(true);
    try {
      const { data } = await api.post(`/leads/${lead.id}/sms-draft`);
      const phone = (data.phone || c.phone || "").replace(/\s+/g, "");
      if (!phone) toast("Pas de numéro sur la fiche : choisissez le destinataire dans votre appli SMS");
      window.location.href = `sms:${phone}?&body=${encodeURIComponent(data.message || "")}`;
    } catch { toast.error("Impossible de rédiger le SMS"); }
    finally { setSmsLoading(false); }
  };

  if (rdv) return <ApptEditDialog appt={{ kind: "rdv", title: `Métré — ${name}`, clientName: name, leadId: lead.id, startAt: `${tomorrow}T09:00:00`, type: "Présentiel" }} onClose={onClose} />;

  return (
    <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/40 backdrop-blur-sm p-4" data-testid="capture-success">
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
        {Array.from({ length: 36 }).map((_, i) => (
          <span key={i} className="klt-confetti" style={{ left: `${(i * 37) % 100}%`, background: COLORS[i % COLORS.length], animationDelay: `${(i % 9) * 0.08}s`, transform: `rotate(${i * 23}deg)` }} />
        ))}
      </div>
      <div className="relative w-full max-w-sm rounded-3xl bg-card p-6 text-center shadow-2xl klt-pop">
        <button onClick={onClose} className="absolute top-3 right-3 w-8 h-8 rounded-full hover:bg-secondary flex items-center justify-center" data-testid="capture-success-close"><X className="w-4 h-4" /></button>
        <div className="mx-auto w-16 h-16 rounded-full klt-fab-neon flex items-center justify-center klt-badge-pop"><Award className="w-8 h-8" /></div>
        <p className="font-heading text-xl font-extrabold mt-4">Lead capturé ! 🎉</p>
        <p className="text-sm text-muted-foreground mt-1" data-testid="capture-success-name">{name}{c.company && name !== c.company ? ` · ${c.company}` : ""}</p>
        <div className="grid gap-2 mt-6">
          <button onClick={() => setRdv(true)} data-testid="capture-success-rdv" className="h-12 rounded-2xl bg-primary text-primary-foreground font-semibold inline-flex items-center justify-center gap-2 hover:opacity-90 transition-opacity"><CalendarClock className="w-4 h-4" /> Fixer un RDV métré</button>
          <button onClick={sendSms} disabled={smsLoading} data-testid="capture-success-sms" className="h-12 rounded-2xl bg-secondary font-semibold inline-flex items-center justify-center gap-2 hover:bg-accent transition-colors disabled:opacity-60">
            {smsLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <MessageSquareText className="w-4 h-4" />} Envoyer un SMS de remerciement IA
          </button>
        </div>
      </div>
    </div>
  );
}
